document.addEventListener('DOMContentLoaded', function () {
  const footerBlock = document.querySelector('.footer__block.footer__block--text');

  if (footerBlock) {
    const img = document.createElement('img');
    img.src = 'https://cdn.shopify.com/s/files/1/0608/2569/8474/files/halal-industry-development-corporation-malaysian-cuisine-halal-certification-in-australia-department-of-islamic-development-malaysia-halal-certified-logo-m-c64b6651157aa4ee2bc02574cb4.png?v=1762916895';
    img.className = 'footer-halal';

    footerBlock.appendChild(img); 
  }
});


(function () {
  const SVG_ICON = `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0)">
        <path d="M13.5 7V3.5C13.5 3.36739 13.4473 3.24021
          13.3536 3.14645C13.2598 3.05268 13.1326 3 13 3H3
          C2.86739 3 2.74021 3.05268 2.64645 3.14645
          C2.55268 3.24021 2.5 3.36739 2.5 3.5V7
          C2.5 13 8 14.5 8 14.5C8 14.5 13.5 13 13.5 7Z"
          stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5.5 8.5L7 10L10.5 6.5"
          stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  `;

  function addFreshnessBadge(button) {
    if (button.querySelector('.freshness-badge')) return;

    const span = document.createElement('span');
    span.className = 'freshness-badge';
    span.innerHTML = `${SVG_ICON} Freshness Guaranteed`;

    span.style.display = 'flex';
    span.style.alignItems = 'center';
    span.style.justifyContent = 'center';
    span.style.gap = '3px';
    span.style.fontSize = '12px';
    span.style.fontWeight = '300';

    button.appendChild(span);
  }

  function updateButtons() {
    const buttons = document.querySelectorAll(
      '.buy-buttons button[type="submit"].button'
    );
    buttons.forEach(addFreshnessBadge);
  }

  // Initial run
  updateButtons();

  // Observe DOM for dynamic button updates
  const observer = new MutationObserver(updateButtons);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true, // handle attribute changes too
    attributeFilter: ["class", "data-selected", "data-variant"] // optional
  });
})();


// Feature icons
document.addEventListener('DOMContentLoaded', function () {
  const moveFeatureBadges = () => {
    const features = document.querySelectorAll(
      '.product-info__block-item[data-block-type="hidden-feature-with-icon"]'
    );
    const buyButtons = document.querySelector('buy-buttons');

    if (!features.length || !buyButtons) return false;

    // Add 15px margin-bottom to the first feature only
    features[0].classList.add('first-feature-margin');

    features.forEach(feature => {
      buyButtons.insertAdjacentElement('afterend', feature);
    });

    return true;
  };

  // Run immediately
  if (moveFeatureBadges()) return;

  // Shopify dynamic render fallback
  const observer = new MutationObserver(() => {
    if (moveFeatureBadges()) observer.disconnect();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// add on buttons

(function () {
  const SVG_ICON = `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
      xmlns="http://www.w3.org/2000/svg" style="margin-left:8px;">
      <g clip-path="url(#clip0)">
        <path d="M2.5 8H13.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8 2.5V13.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  `;

  function updateButtons() {
    document.querySelectorAll(
      ".gs__upsell-btn.gs__multi-carousel-upsell-btn"
    ).forEach(btn => {
      if (!btn.dataset.updated) {
        btn.innerHTML = `
          <span style="display:inline-flex; align-items:center;">
            Add to cart
            ${SVG_ICON}
          </span>
        `;
        btn.dataset.updated = "true";
      }
    });
  }

  // Run immediately
  updateButtons();

  // Observe DOM changes (for dynamically injected buttons)
  const observer = new MutationObserver(updateButtons);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// Buy it now => Buy Now button
// Function to change button text
function changeButtonText() {
  const buttons = document.querySelectorAll('.shopify-payment-button__button--unbranded');

  buttons.forEach(button => {
    if (button.textContent.trim() === 'Buy it now') {
      button.textContent = 'Buy Now';
    }
  });
}


// Initial change
changeButtonText();

// Set up MutationObserver to watch for changes
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList' || mutation.type === 'characterData') {
      changeButtonText();
    }
  });
});

// Start observing the document body for changes
observer.observe(document.body, {
  childList: true,
  subtree: true,
  characterData: true,
  characterDataOldValue: true
});